export const FEE_MODAL_TYPE = {
  cancelation: "cancelation",
  noShow: "noShow",
};
